// extracted by mini-css-extract-plugin
export default {"salePrice":"Price_salePrice__Z3+oG","normalPrice":"Price_normalPrice__7EpxM","noClick":"Price_noClick__PG28k"};